import { PageHero } from '../components/ui/PageHero.jsx';
import { Section, Wrap, Grid } from '../components/ui/Section.jsx';
import { Reveal } from '../components/ui/motion.jsx';
import { Eyebrow } from '../components/ui/Eyebrow.jsx';
import { Card } from '../components/ui/Card.jsx';
import { ContactForm } from '../features/contact/ContactForm.jsx';
import { site, contact, hours } from '../data/site.js';
import styles from './ContactPage.module.css';

export const meta = {
  title: 'Contact — Abode Custom Homes',
  description:
    "Tell Abode Custom Homes about your project and we'll follow up within one business day — whether you have a lot picked out or you're still exploring.",
};

export default function ContactPage() {
  return (
    <>
      <PageHero
        eyebrow="Get In Touch"
        lines={["Let's talk about", 'your home.']}
        lede="Tell us a little about your project and we'll follow up within one business day — whether you have a lot picked out or you're still exploring."
      />

      <Section>
        <Wrap>
          <Grid cols={2} className={styles.columns}>
            <Reveal>
              <Eyebrow animated={false}>Project Inquiry</Eyebrow>
              <ContactForm />
            </Reveal>

            <Reveal>
              <Eyebrow animated={false}>Direct Contact</Eyebrow>
              <Card className="mt-4">
                <p>
                  <strong>Phone</strong><br />
                  <a className="underlined" href={contact.phoneHref}>{contact.phone}</a>
                </p>
                <p className="mt-3">
                  <strong>Email</strong><br />
                  <a className="underlined" href={contact.emailHref}>{contact.email}</a>
                </p>
                <p className="mt-3">
                  <strong>Location</strong><br />
                  {site.location}<br />
                  {site.serviceArea}
                </p>
                <p className="mt-3">
                  <strong>Hours</strong><br />
                  {hours.map(({ days, time }, i) => (
                    <span key={days}>
                      {i > 0 ? <br /> : null}
                      {days}: {time}
                    </span>
                  ))}
                </p>
              </Card>
            </Reveal>
          </Grid>
        </Wrap>
      </Section>
    </>
  );
}
